import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readApplicationSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

const useReadApplicationSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readApplicationSelectBox"],
        queryFn: async () => readApplicationSelectBoxApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
    });
    return {data};
};

export default useReadApplicationSelectBox;
